import type { ReactNode } from 'react'
import type { RenderElementProps } from 'slate-react'
import type { LinkElement } from 'modules/community/types/custom-editor'

export interface CustomRenderLinkProps extends RenderElementProps {
  element: LinkElement
}

// TODO: Remove
const Link = ({ attributes, element, children }: CustomRenderLinkProps): ReactNode => {
  return (
    <a {...attributes} href={element.url}>
      {children}
    </a>
  )
}

export default Link
